import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { AppComunLoginComponent } from './royal/modulos/framework-seguridad/vista/app.comun-login.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
      { path: '', component: AppComunLoginComponent },
      { path: 'login/:user/:company', component: AppComunLoginComponent },
      {
        path: 'portal', component: AppMainComponent,
        children: [
          {
            path: 'error', children: [
              { path: 'listado', component: AppComunLoginComponent },
            ]
          },

        ]
      },
      { path: 'error', component: AppComunLoginComponent },
      { path: 'notfound', component: AppComunLoginComponent },
      { path: '**', redirectTo: '/notfound' },
    ], { scrollPositionRestoration: 'enabled' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
